var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4332_28239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4332_28239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 9L6 7.2L7.8 9L8.5 8.3L6.7 6.5L8.5 4.7L7.8 4L6 5.8L4.2 4L3.5 4.7L5.3 6.5L3.5 8.3L4.2 9ZM6 11.5C5.30833 11.5 4.65833 11.3687 4.05 11.1062C3.44167 10.8437 2.9125 10.4875 2.4625 10.0375C2.0125 9.5875 1.65625 9.05833 1.39375 8.45C1.13125 7.84167 1 7.19167 1 6.5C1 5.80833 1.13125 5.15833 1.39375 4.55C1.65625 3.94167 2.0125 3.4125 2.4625 2.9625C2.9125 2.5125 3.44167 2.15625 4.05 1.89375C4.65833 1.63125 5.30833 1.5 6 1.5C6.69167 1.5 7.34167 1.63125 7.95 1.89375C8.55833 2.15625 9.0875 2.5125 9.5375 2.9625C9.9875 3.4125 10.3437 3.94167 10.6062 4.55C10.8687 5.15833 11 5.80833 11 6.5C11 7.19167 10.8687 7.84167 10.6062 8.45C10.3437 9.05833 9.9875 9.5875 9.5375 10.0375C9.0875 10.4875 8.55833 10.8437 7.95 11.1062C7.34167 11.3687 6.69167 11.5 6 11.5ZM6 10.5C7.11667 10.5 8.0625 10.1125 8.8375 9.3375C9.6125 8.5625 10 7.61667 10 6.5C10 5.38333 9.6125 4.4375 8.8375 3.6625C8.0625 2.8875 7.11667 2.5 6 2.5C4.88333 2.5 3.9375 2.8875 3.1625 3.6625C2.3875 4.4375 2 5.38333 2 6.5C2 7.61667 2.3875 8.5625 3.1625 9.3375C3.9375 10.1125 4.88333 10.5 6 10.5Z",
    fill: "#C70F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.7e81c40e38c45ca68bfc61388cd03565.svg";
export { ForwardRef as ReactComponent };